import { SPELLCAST_ROLL, DOMAIN_CARD } from '../../character/content/templates';

export default function Multiclassing() {
  return (
    <>
      <p>Starting at level 5, you can choose multiclassing as an option when leveling up. When you multiclass, you choose an additional class, gain access to one of its domains, and acquire its class feature. Take the appropriate multiclass module and add it to the right side of your character sheet, then choose a foundation {DOMAIN_CARD} from one of its subclasses. If your foundation cards specify different Spellcast traits, you can choose which one to apply when making a {SPELLCAST_ROLL}.</p>
      <p>Whenever you have the option to acquire a new {DOMAIN_CARD}, you can choose from cards at or below half your current level (rounded up) from the domain you chose when you selected the multiclass advancement.</p>
    </>
  );
}
